import React, { FunctionComponent, ReactNode, useEffect, useRef, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import './styles.scss';

type ReadMoreProps = {
  children: ReactNode;
}

const ReadMore: FunctionComponent<ReadMoreProps> = ({ children }) => {
  const { sanityLabels } = useStaticQuery(graphql`
    {
      sanityLabels {
        generalLabels {
          readMore
          readLess
        }
      }
    }
  `);

  const [clamped, setClamped] = useState(true);
  const [showButton, setShowButton] = useState(true);
  const divRef = useRef<HTMLDivElement>(null);

  const readMore = sanityLabels?.generalLabels?.readMore ?? 'Read more';
  const readLess = sanityLabels?.generalLabels?.readLess ?? 'Read less';

  useEffect(() => {
    const hasClamping = (div: HTMLDivElement) => {
      const { clientHeight, scrollHeight } = div;
      return clientHeight !== scrollHeight;
    };

    function checkButtonAvailability() {
      const div = divRef.current;

      if (div) {
        const hadClampClass = div.classList.contains('clamped');

        if (!hadClampClass) {
          div.classList.add('clamped');
        }
        setShowButton(hasClamping(div));

        if (!hadClampClass) {
          div.classList.remove('clamped');
        }
      }
    }

    checkButtonAvailability();
    window.addEventListener('resize', checkButtonAvailability);

    return () => {
      window.removeEventListener('resize', checkButtonAvailability);
    };
  }, [divRef]);


  return (
    <div>
      <div
        className={clamped ? 'clamped' : undefined}
        ref={divRef}
      >
        {children}
      </div>
      {showButton && (
        <button
          type='button'
          onClick={() => setClamped(current => !current)}
          className='read-more-button'
        >
          {clamped ? readMore : readLess}
        </button>
      )}
    </div>
  );
}

export default ReadMore;

